module.exports = __webpack_public_path__ + "static/media/clases-2.81f8f8b7.jpg";